import React from 'react'
import styled from 'styled-components'
import Fade from 'react-reveal/Fade'

function Section({title,description,image}) {
    return (
        <Wrap bgImage={image}>
            <Fade bottom>
                <ItemText>
                    <h1>{title}</h1>
                    <p>{description}</p>
                </ItemText>
            </Fade>
            <Buttons>
                <Fade bottom>
                    <ButtonGroup>
                        <LeftButton>
                            Custom Order
                        </LeftButton>

                        <RightButton>
                            Existing Inventory
                        </RightButton>
                    </ButtonGroup>
                </Fade>
                <DownArrow src='/images/down-arrow.svg'/>
            </Buttons>
        </Wrap>
    )
}

export default Section

const Wrap = styled.div`
    z-index:10;
    width:100%;
    height:100vh;
    background-size:cover;
    background-position:center;
    background-repeat:no-repeat;
    background-image:${props=>`url("/images/${props.bgImage}")`};
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    align-items:center;
`

const ItemText = styled.div`
    align-items:center;
    padding-top:15vh;

`

const ButtonGroup = styled.div`
    margin-bottom: 30px;
    display:flex;
    @media (max-width:768px){
        flex-direction:column
    }
`

const LeftButton = styled.div`
    align-items:center;
    background-color:rgba(23,26,32,0.8);
    height:40px;
    width:256px;
    color:white;
    border-radius: 100px;
    display:flex;
    justify-content:center;
    opacity:0.85vh;
    text-transform:uppercase;
    font-size:12px;
    cursor:pointer;
    margin:10px;
`

const RightButton = styled(LeftButton)`
    background-color:white;
    color:rgba(23,26,32,0.8);
`

const DownArrow = styled.img`
    margin-top:20px;
    height:40px;
    animation: animateDown infinite 1.5s;
    overflow-x:hidden;
`

const Buttons = styled.div`
`